import { MediaAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";

/** 媒体组件类 */
export class MediaComponent extends BaseComponent<
  MediaAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  // constructor(data: Partial<BaseComponent<MediaAttrs>> = {}) {
  //   super(data);
  //   this.type = CompType.media;
  // }
  /** 获取标题文本 */
  // public getTitleText(): string {
  //   return this.lang_attrs.title;
  // }
  // /** 设置标题文本 */
  // public setTitleText(text: string): void {
  //   this.setAttrs({ title: text });
  // }
  // /** 获取媒体数据列表 */
  // public getMediaItems(): MediaItem[] {
  //   return this.lang_attrs.list;
  // }
  // /** 设置媒体数据列表 */
  // public setMediaItems(items: MediaItem[]): void {
  //   this.setAttrs({ list: items });
  // }
}

// 使用示例
// const mediaData: Partial<BaseComponent<MediaAttrs>> = {
//   id: "673c647d0552d8e3fc789f6d",
//   type: CompType.media,
//   variant: "",
//   title: "加入我們1",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "footer_media",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_text: {
//       "4": "加入我們",
//       "11": "Join Our Community",
//       "12": "Join Our Community",
//       "1": "Join Our Community",
//     },
//     data_list: [
//       {
//         click_params: "",
//         title: "Whatapp",
//         img_url:
//           "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/C02/share/whatsapp.png?20240416",
//         deny_pack: [],
//         key: 1732528764625,
//         status: 1,
//         click_id: 11,
//       },
//     ],
//   },
// };
